import { useState, useEffect } from 'react'
import { getEmpsCodeAPI } from '../services/employee'

function UseEmpsCode(orgId, searchs) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getEmpsCodeAPI({ orgId, searchs })
      if (!result) return

      const newData =
        result.result &&
        result.result.map((d, i) => {
          return { value: d.code, label: d.code }
        })

      setData(newData)
    }
    if (orgId) {
      getData()
    }
  }, [orgId, searchs])

  return data
}

export default UseEmpsCode
